import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { Uuid } from 'src/utils/uuid.util';

@Component({
    selector: 'app-carousel-simple',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './carousel-simple.component.html',
    styleUrl: './carousel-simple.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselSimpleComponent implements OnInit, OnDestroy {
    id = 'carousel-' + Uuid.create();
    @Input()
    icon: string = 'arrow';
    @HostBinding('style.--items-shown')
    @Input()
    shownCount: string = '4';
    @HostBinding('style.--min')
    @Input()
    minwidth: string = '260px';
    @HostBinding('style.--gap')
    @Input()
    gap: string = '20px';
    atStart: boolean = true;
    atEnd: boolean = true;
    @Input()
    step: 'item' | 'full' = 'item';
    check: Subject<void>;
    sub: Subscription;
    observer: MutationObserver;
    mustationObserverConfig: MutationObserverInit = {
        attributes: true
    };

    get stepSize(): number {
        if (this.step == 'item' && this.track.firstElementChild)
            return this.track.firstElementChild.clientWidth;
        return this.track.clientWidth;
    }
    get track(): HTMLDivElement {
        return window[this.id];
    }
    constructor(
        private _elm: ElementRef<HTMLElement>,
        private _detector: ChangeDetectorRef,
    ) {}


    ngOnDestroy(): void {
        if (this.sub != null && !this.sub.closed)
            this.sub.unsubscribe();
        if (this.observer != null)
            this.observer.disconnect();

    }
    ngOnInit(): void {
        if (+this.shownCount < 1)
            this.shownCount = '4';

        this.check = new Subject<void>();
        this.sub = this.check.pipe(debounceTime(10)).subscribe(() => {
            if (this.track == null || this.track.firstElementChild == null)
                return;
            this.atStart = this.track.scrollLeft < (this.track.firstElementChild.clientWidth / 2);
            this.atEnd = this.track.scrollLeft + this.track.clientWidth + (this.track.firstElementChild.clientWidth / 2) > this.track.scrollWidth;
            this._detector.markForCheck();
        });
        var dialog = this._elm.nativeElement.closest('dialog');
        if (dialog != null) {
            this.observer = new MutationObserver((mutationList, observer) => mutationList.some(mutation => mutation.type ==='attributes' && dialog.open) ? this.scrollUpdate() : null);
            this.observer.observe(dialog, this.mustationObserverConfig);
        }
        else
            setTimeout(() => {
                this.scrollUpdate()
            }, 500);
    }
    scrollBack() {
        this.track.scrollBy({ left: -this.stepSize, top: 0, behavior: 'smooth' });
        this.scrollUpdate();
    }
    scrollForward() {
        this.track.scrollBy({ left: this.stepSize, top: 0, behavior: 'smooth' });
        this.scrollUpdate();
    }
    scrollUpdate() {
        queueMicrotask(() => { this.check.next() });
    }
}
